// src/pages/administrasi/rabReference.js
//
// Seed suggestions for the Anggaran (RAB) quick-add: Section -> Kode ->
// [{uraian, satuan}], taken from a real past event's RAB
// (RAB-LISOKOM-KUBROMUHARRAM1448H-2026M.xlsx, "2026M-1448H KUBRO MUHARRAM").
// Purely a starting point for autocomplete — Section/Kode/Uraian stay free
// text everywhere they're used, since every event's actual breakdown
// differs from the last one.
const RAB_REFERENCE = {
  SEKBEN: {
    Administrasi: [
      { uraian: "Fc, Print, Print Copy", satuan: "Paket" },
      { uraian: "Print LPJ", satuan: "Paket" },
      { uraian: "Klip Besi Besar", satuan: "Pack" },
      { uraian: "Klip Besi Kecil", satuan: "Pack" },
      { uraian: "Map Kertas", satuan: "Buah" },
      { uraian: "Map Tas Kancing", satuan: "Buah" },
      { uraian: "Cetak Label", satuan: "Paket" },
      { uraian: "Spidol Permanent", satuan: "Buah" },
      { uraian: "Snail Map", satuan: "Buah" },
      { uraian: "Kwitansi", satuan: "Buah" },
    ],
  },
  LISTRIK: {
    "Pengadaan Barang": [
      { uraian: "Solasi Warna RST", satuan: "Buah" },
      { uraian: "Solasi Nasional", satuan: "Buah" },
      { uraian: "Spons Doubletipe", satuan: "Roll" },
      { uraian: "Volt Meter", satuan: "Buah" },
      { uraian: "Ampere Meter", satuan: "Buah" },
      { uraian: "Kabel NYA 2,5mm", satuan: "Roll" },
      { uraian: "Steker Bulat", satuan: "Buah" },
      { uraian: "Kabel Twisted", satuan: "Meter" },
      { uraian: "Handy Talky", satuan: "Set" },
      { uraian: "Saklar", satuan: "Pack" },
      { uraian: "Floodlight 200w", satuan: "Buah" },
    ],
    Perawatan: [
      { uraian: "Contact Cleaner", satuan: "Buah" },
      { uraian: "Sekrup", satuan: "Paket" },
      { uraian: "Skun", satuan: "Paket" },
      { uraian: "Mur Baut", satuan: "Paket" },
      { uraian: "Mata Bor", satuan: "Paket" },
      { uraian: "Baterai A3", satuan: "Set" },
      { uraian: "Servis Panel", satuan: "Paket" },
      { uraian: "Servis Lighting", satuan: "Paket" },
    ],
    "Sewa & PLN": [
      { uraian: "Sewa Genset 40 KVA", satuan: "Unit" },
      { uraian: "Sewa Genset 60 KVA", satuan: "Unit" },
      { uraian: "Sewa Genset 20 KVA", satuan: "Unit" },
      { uraian: "Sewa Genset 100 KVA", satuan: "Unit" },
      { uraian: "Izin Pesta", satuan: "Titik" },
      { uraian: "Token Pulsa", satuan: "Paket" },
    ],
  },
  SOUND: {
    "Pengadaan Barang": [
      { uraian: "DLMS", satuan: "Unit" },
      { uraian: "Power", satuan: "Unit" },
      { uraian: "Speaker", satuan: "Unit" },
      { uraian: "Tweeter", satuan: "Unit" },
      { uraian: "Horn Tweeter", satuan: "Unit" },
    ],
    Perawatan: [
      { uraian: "Servis Speaker", satuan: "Paket" },
      { uraian: "Servis Sound", satuan: "Paket" },
    ],
    Sewa: [
      { uraian: "Sewa Sound System", satuan: "Paket" },
      { uraian: "Sewa Power", satuan: "Paket" },
    ],
  },
  LOGISTIK: {
    "Barang Habis Pakai": [
      { uraian: "Kabel Ties Besar", satuan: "Pack" },
      { uraian: "Lakban Bening", satuan: "Roll" },
      { uraian: "Cemiti", satuan: "Box" },
      { uraian: "Rafia", satuan: "Roll" },
      { uraian: "Isi Ulang Galon", satuan: "Buah" },
      { uraian: "Kawat", satuan: "Kg" },
      { uraian: "Isi Cutter", satuan: "Pack" },
      { uraian: "Isolasi Hitam", satuan: "Slop" },
      { uraian: "Isolasi Kertas", satuan: "Slop" },
      { uraian: "Keranjang Industri", satuan: "Buah" },
      { uraian: "Lem G", satuan: "Pack" },
      { uraian: "Gelas Plastik", satuan: "Slop" },
      { uraian: "Plastik", satuan: "Pack" },
      { uraian: "BBM", satuan: "Paket" },
    ],
    Perawatan: [
      { uraian: "PCB LED Besar", satuan: "Buah" },
      { uraian: "Tang Lampu", satuan: "Set" },
      { uraian: "Servis Lampu", satuan: "Paket" },
    ],
    Sewa: [
      { uraian: "Lampu LED", satuan: "Buah" },
    ],
  },
};

export function referenceKodeMap(section) {
  const key = Object.keys(RAB_REFERENCE).find(
    (k) => k.toLowerCase() === (section || "").trim().toLowerCase()
  );
  return key ? RAB_REFERENCE[key] : null;
}

export function referenceUraianList(section, kode) {
  const kodeMap = referenceKodeMap(section);
  if (!kodeMap) return [];
  const key = Object.keys(kodeMap).find(
    (k) => k.toLowerCase() === (kode || "").trim().toLowerCase()
  );
  return key ? kodeMap[key] : [];
}

export default RAB_REFERENCE;
